import { SET_SETTINGS_CHANGE_DATA, SET_SETTINGS_DIFF_OBJECT, SET_SETTINGS_CHANGE_DATA_VALUES, UPDATE_SETTINGS_CHANGE_DATA_VALUES, RESET_SETTINGS_CHANGE_DATA, RESET_SETTINGS_CHANGES, SET_SELECTED_SETTINGS_LOCATIONS, UPDATE_SETTINGS_ERRORS, CLEAR_SETTINGS_ERROR, SET_SETTINGS_ERRORS } from './chunk-DHR2SCPN.mjs';
import { __export } from './chunk-T36PI2YV.mjs';

// src/state/settings/changeData/actions.ts
var actions_exports = {};
__export(actions_exports, {
  clearSettingsError: () => clearSettingsError,
  resetSettingsChangeData: () => resetSettingsChangeData,
  resetSettingsChanges: () => resetSettingsChanges,
  setSelectedSettingsLocations: () => setSelectedSettingsLocations,
  setSettingsChangeData: () => setSettingsChangeData,
  setSettingsChangeDataValues: () => setSettingsChangeDataValues,
  setSettingsDiffObject: () => setSettingsDiffObject,
  setSettingsErrors: () => setSettingsErrors,
  updateSettingsChangeDataValues: () => updateSettingsChangeDataValues,
  updateSettingsErrors: () => updateSettingsErrors
});
var setSettingsChangeData = (payload) => ({
  type: SET_SETTINGS_CHANGE_DATA,
  payload
});
var setSettingsDiffObject = (payload) => ({
  type: SET_SETTINGS_DIFF_OBJECT,
  payload
});
var setSettingsChangeDataValues = (data, sectionId = "all") => ({
  type: SET_SETTINGS_CHANGE_DATA_VALUES,
  payload: { data, sectionId }
});
var updateSettingsChangeDataValues = (payload) => ({
  type: UPDATE_SETTINGS_CHANGE_DATA_VALUES,
  payload
});
var resetSettingsChangeData = () => ({
  type: RESET_SETTINGS_CHANGE_DATA
});
var resetSettingsChanges = (payload) => ({
  type: RESET_SETTINGS_CHANGES,
  payload
});
var setSelectedSettingsLocations = (payload) => ({
  type: SET_SELECTED_SETTINGS_LOCATIONS,
  payload
});
var updateSettingsErrors = (payload) => ({
  type: UPDATE_SETTINGS_ERRORS,
  payload
});
var clearSettingsError = (payload) => ({
  type: CLEAR_SETTINGS_ERROR,
  payload
});
var setSettingsErrors = (payload) => ({
  type: SET_SETTINGS_ERRORS,
  payload
});

export { actions_exports, clearSettingsError, resetSettingsChangeData, resetSettingsChanges, setSelectedSettingsLocations, setSettingsChangeData, setSettingsChangeDataValues, setSettingsDiffObject, setSettingsErrors, updateSettingsChangeDataValues, updateSettingsErrors };
